import DashboardChartFilters from "./DashboardChartFilters";

export default DashboardChartFilters;
